class SupportMarketRateImagePresenterPresentation
  present: (images) ->
    return null unless images?.length > 0
    image = _.first images
    url = image?.url
    if url?
      unless url.match(/http/)?.index is 0 or url.indexOf("//") is 0
        url = "https://#{url}"
      parts = url.split("/v1/")
      parts = ( _.initial parts ) if ( _.last parts ) is ''
      if parts? then _.reduce parts, (memo, part) -> "#{memo}/#{part}"

module.exports = SupportMarketRateImagePresenterPresentation
